module.exports = __webpack_public_path__ + "img/DW365-088.533c9f24.jpg";